import React, { Component } from 'react';

// Externals
import PropTypes from 'prop-types';

// Material helpers
import { withStyles } from '@material-ui/core/styles';

import Lights from '../../../Dashboard/components/Lights';


// Component styles
const styles = theme => ({
    root: {
        padding: theme.spacing(3),
        backgroundColor: '#525252',
        height: '100%',
        width: '100%',
    },
    item: {
        height: '100%',
        width: '100%',
    }
});

class UserLights extends Component {
    constructor(props) {
        super(props);
        this.myCallback = this.myCallback.bind(this);
        this.state = {
            objectivesList: {}
        } 
    }
    myCallback = (dataFromChild) => {

        this.setState({
            objectivesList: dataFromChild
        })


    }

    render() {
        const { classes } = this.props;
        const { objectivesList } = this.state
        return (
            <div>
                <Lights params={objectivesList} />
            </div>
        );
    }
}

UserLights.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(UserLights);
